import { useManagementInfo } from "hooks/api/use-management-info";
import { env } from "env";

// Auto-generated type for /management/info endpoint has unknown properties,
// so we need to cast it to a known type
type ManagementInfoDeploy = {
  git?: { commit?: { id?: { abbrev?: string } } };
  build?: { time?: string };
};

export const DeployInfo = () => {
  const { data } = useManagementInfo();

  const info = data as ManagementInfoDeploy | undefined;
  const abbrev = info?.git?.commit?.id?.abbrev;
  const buildTime = info?.build?.time;

  return (
    <div className="mt-auto py-4 text-center text-sm text-gray-900" data-testid="deploy-info">
      {`${abbrev} built on ${buildTime}`}
    </div>
  );
};
